import type { FC, ReactNode } from 'react';
import { HiSortAscending, HiSortDescending } from 'react-icons/hi';
import { IconButton } from '@mui/material';

import { useTicketTableContext } from 'src/components/followUp/TicketFilterContext';

import TicketTableCell from './TicketTableCell';

interface HeaderTableCellProps {
  columnKey: string;
  minWidth: string;
  children?: ReactNode;
}

const HeaderTableCell: FC<HeaderTableCellProps> = ({
  children,
  columnKey,
  minWidth,
}) => {
  const { sortBy, setSortBy } = useTicketTableContext();
  return (
    <TicketTableCell isHead sxOverride={{ minWidth }}>
      {children}
      <IconButton
        aria-label={`${columnKey}-sort-button`}
        onClick={() =>
          setSortBy((prev) =>
            prev === `-${columnKey}` ? columnKey : `-${columnKey}`,
          )
        }
      >
        {sortBy === `-${columnKey}` ? (
          <HiSortDescending size={16} color="red" />
        ) : (
          <HiSortAscending
            size={16}
            color={sortBy === columnKey ? 'red' : 'inherit'}
          />
        )}
      </IconButton>
    </TicketTableCell>
  );
};

export default HeaderTableCell;
